import { useCallback, useEffect, useState } from 'react';

const KEY = 'caleb:room';

// The room light is a property of the whole site, not of one page, so it
// lives on <html> and persists. Pages just read it.
const apply = (room) => {
  document.documentElement.setAttribute('data-room', room);
};

const initial = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'lit' || saved === 'safe') return saved;
  } catch {
    /* private mode, blocked storage — fall through to the default */
  }
  return 'lit';
};

export default function useRoom() {
  const [room, setRoom] = useState(initial);

  useEffect(() => {
    apply(room);
    try {
      localStorage.setItem(KEY, room);
    } catch {
      /* nothing to do: the attribute above is what actually themes the page */
    }
  }, [room]);

  const toggle = useCallback(() => {
    setRoom((r) => (r === 'lit' ? 'safe' : 'lit'));
  }, []);

  return { room, lit: room === 'lit', toggle };
}
